import * as yup from 'yup';

export default (isAgency: boolean) =>
  yup.object().shape({
    accountName: yup.string().required(),
    advertiserId: yup.string().required('requiredAdvertiserMessage'),
    ...(!isAgency ? { accountManagerIds: yup.array().required('requiredAccountManagers') } : {})
  });
